<template lang="html">
  <div class="w-full">
    <input type="hidden" :value="selected_city.id" name="user[profile_attributes][city_id]">
    <input type="hidden" :value="selected_city.id" name="profile[city_id]">
    <input type="hidden" :value="selected_city.id" name="room[city_id]">
    <button type="button" class="form-input relative" aria-haspopup="listbox" aria-expanded="true"
            aria-labelledby="listbox-label" @click="show_time_zone_modal = true">
      <span class="w-full inline-flex truncate">
        <span class="truncate">
          {{ selected_city.name }}
        </span>
        <span class="ml-2 truncate text-gray-500" v-show="selected_city.country_name">
          {{ selected_city.country_name }}
          <img class="w-4 h-4 inline-block mr-1" :src="'/images/flags/'+selected_city.iso_alpha_2_code+'.svg'"
               alt="Country flag for city"/>
        </span>
      </span>
      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <!-- Heroicon name: solid/selector -->
        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
             aria-hidden="true">
          <path fill-rule="evenodd"
                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                clip-rule="evenodd"/>
        </svg>
      </span>
    </button>
    <modal :showModal="show_time_zone_modal" @close="show_time_zone_modal = false">
      <h1 class="text-2xl font-bold pt-4 pb-4">Search for a city</h1>
      <div class="relative">
        <input class="form-input" type="text" v-model="query" @keyup="loadCities"
               placeholder="Type in a City, e.g., New York City, Los Angeles, Lima "/>
        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <!-- Loading icon -->
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-200" xmlns="http://www.w3.org/2000/svg" fill="none"
               viewBox="0 0 24 24" v-show="loading_cities">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      </div>
      <div class="mt-5 relative h-96">
        <p class="text-gray-400 text-sm" v-show="show_options"> Showing {{ cities.length }} results </p>
        <ul class="p-0 w-full max-h-80 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm"
            tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3"
            v-show="show_options">
          <!--
              Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

              Highlighted: "text-white bg-blue-600", Not Highlighted: "text-gray-900"
          -->
          <li class="group text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:text-white hover:bg-blue-600"
              :class="" id="listbox-option-0" role="option" v-for="city in cities"
              @click="selected_city = city;show_time_zone_modal = false">
            <div class="flex">
              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
              <span class="font-normal truncate">
                {{ city.name }}
              </span>
              <!-- Highlighted: "text-blue-200", Not Highlighted: "text-gray-500" -->
              <span class="text-gray-500 ml-2 truncate group-hover:text-blue-200">
                {{ city.province }}
              </span>
              <span class="text-gray-500 ml-2 truncate  group-hover:text-blue-200">
                <img class="w-4 h-4 inline-block mr-1" :src="'/images/flags/'+city.iso_alpha_2_code+'.svg'"
                     alt="Country flag for city"/>
                {{ city.country_name }}
              </span>
            </div>

            <!--
            Checkmark, only display for selected option.

            Highlighted: "text-white", Not Highlighted: "text-blue-600"
            -->
            <span class="text-blue-600 absolute inset-y-0 right-0 flex items-center pr-4 group-hover:text-white"
                  v-show="selected_city.id == city.id">
              <!-- Heroicon name: solid/check -->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                   aria-hidden="true">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"/>
              </svg>
            </span>
          </li>
        </ul>
        <div class="flex justify-center items-center h-full" v-show="!show_options">
          <div class="space-y-4">
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <!-- Search icon -->
              <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="512"
                   height="512" viewBox="0 0 512 512"><title>ionicons-v5-f</title>
                <path
                    d="M456.69,421.39,362.6,327.3a173.81,173.81,0,0,0,34.84-104.58C397.44,126.38,319.06,48,222.72,48S48,126.38,48,222.72s78.38,174.72,174.72,174.72A173.81,173.81,0,0,0,327.3,362.6l94.09,94.09a25,25,0,0,0,35.3-35.3ZM97.92,222.72a124.8,124.8,0,1,1,124.8,124.8A124.95,124.95,0,0,1,97.92,222.72Z"/>
              </svg>
            </div>
            <div class="text-lg font-bold">
              Search for a city
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 space-x-2 text-center">
        <button type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 overflow-hidden focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                @click="show_time_zone_modal = false;">
          Close
        </button>
      </div>
    </modal>
  </div>
</template>
<script>

import axios from 'axios'

export default {
  props: {
    userSelectedCity: {}
  },
  data() {
    return {
      query: '',
      selected_city: {
        name: 'Select a city....',
      },
      loading_cities: false,
      cities_timeout: null,
      cities_search_timeout: 300,
      cities: '',
      show_time_zone_modal: false,
      show_options: false,
    }
  },
  mounted() {
    if (this.userSelectedCity){
      this.selected_city = this.userSelectedCity;
      this.selected_city.country_name = this.userSelectedCity.country.name
      this.selected_city.iso_alpha_2_code = this.userSelectedCity.country.iso_alpha_2_code.toLowerCase(); // all flags are in lowercase
    } 
  },
  methods: {
    loadCities() {
      const params = {query: this.query};
      const headers = {'Accept': 'application/json'};
      if (this.cities_timeout) clearTimeout(this.cities_timeout);
      this.cities_timeout = window.setTimeout(() => {
        this.loading_cities = true;
        axios.get('/cities', {params, headers}).then(response => {
          this.cities = JSON.parse(response.data.cities);
          this.show_options = true;
          this.loading_cities = false;
        }).catch(err => {
          console.error(err);
          this.loading_cities = false;
        })
      }, this.cities_search_timeout)
    }
  },
}
</script>
<style lang="">

</style>